import { getProductStockSkuBranches } from '../../services/api/productStock.api';
import { GET_SKU_BRANCH_LIST_REQUEST, GET_SKU_BRANCH_LIST_SUCCESS, GET_SKU_BRANCH_LIST_FAILURE } from '../types';
import { transformStockSkuBranches } from '../../transforms/stock';
import { transformPagination } from '../../transforms/pagination';
import { transformError } from '../../transforms/error';
import { replaceTo } from '../../helpers/utils';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformStockSkuBranches([]),
		pagination: transformPagination({}),
	},

	mutations: {
		[GET_SKU_BRANCH_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_SKU_BRANCH_LIST_SUCCESS](state, { data, meta }) {
			state.isLoading = false;
			state.data = transformStockSkuBranches(data);
			state.pagination = transformPagination(meta);
		},
		[GET_SKU_BRANCH_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getProductStockSkuBranches({ commit }, { id = null, params = {} }) {
			try {
				const sortBy = replaceTo(params.sort_by, [
					{ from: 'branch_id', to: 'itec_branch_id' },
					{ from: 'branch_name', to: 'name' },
					{ from: 'online_stock_quantity', to: 'online_stock_quantity' },
					{ from: 'offline_stock_quantity', to: 'offline_stock_quantity' },
					{ from: 'total_stock_quantity', to: 'total_stock_quantity' },
				]);

				let viewby = null;

				if (params.viewby) {
					viewby = params.viewby;
				} else if (params.min || params.max) {
					viewby = 'all';
				}

				const _params = {
					keyword: params.keyword,
					'filters[location]': params.location,
					'filters[view_stocks]': viewby,
					'filters[min]': params.min,
					'filters[max]': params.max,
					sort_by: sortBy,
					sort_direction: params.sort_direction,
					page: params.page,
					per_page: 30,
				};
				commit(GET_SKU_BRANCH_LIST_REQUEST);
				const { data } = await getProductStockSkuBranches(_params, id);
				commit(GET_SKU_BRANCH_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_SKU_BRANCH_LIST_FAILURE, error);
			}
		},
	},
};
